import { render, staticRenderFns } from "./MyInvestorAccount.vue?vue&type=template&id=48e0c8b5"
import script from "./MyInvestorAccount.vue?vue&type=script&lang=js"
export * from "./MyInvestorAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports